import { Reveal } from '@landsbankinn/ui';
import React from 'react';
import { OrderGiftCard } from '../components/gift-card/order-gift-card/OrderGiftCard';

interface IProps {
  type: 'company' | 'person';
}

export const OrderGiftCardContainer = ({ type }: IProps) => {
  return (
    <div id="order_gift_card">
      <Reveal>
        <OrderGiftCard type={type} />
      </Reveal>
    </div>
  );
};
